
modalClsBtn = document.querySelectorAll('.modal-close')
modalClsBg = document.querySelectorAll('.modal-bg')
if(modalClsBtn?.length > 0) {
  modalClsBtn.forEach(clBtn => {
    clBtn.addEventListener('click', function() {
      // document.querySelector('body').style.overflow = 'auto'
      // enableScroll()
      // document.addEventListener("wheel", (e) => e.preventDefault(), { passive: false });
      // document.addEventListener("touchmove", (e) => e.preventDefault(), { passive: false });
      var container = this.closest('.modal-container');
      if (container) {
        container.classList.remove('open');
      }
      // document.body.style.paddingRight = 0;
    })
  })
}
if(modalClsBg?.length > 0) {
  modalClsBg.forEach(bg => {
    bg.addEventListener('click', function() {
      // document.querySelector('body').style.overflow = 'auto'
      // enableScroll()
      var container = this.closest('.modal-container');
      if (container) {
        container.classList.remove('open');
      }
      // document.body.style.paddingRight = 0;
    })
  })
}

let quickBtn = $('.js-quick-shop-link')
if(quickBtn) {
  quickBtn.click(function() {
    let $this = $(this)
    $($this).find('.text').addClass('hide')
    $($this).find('.laoder-icon').removeClass('hide')
    let loader = setInterval(function() {
      if($('.modal-container').hasClass('open')) {
        $($this).find('.text').removeClass('hide')
        $($this).find('.laoder-icon').addClass('hide')  
        variantPdce()
        clearInterval(loader);
      }
    },500)
  })
}

$(document).on('click','.modal-close', function() {
  $('body').css('overflow', 'auto')
  // enableScroll()
  $(this).closest('.modal-container').removeClass('open')
  // document.body.style.paddingRight = 0;
});
$(document).on('click','.modal-bg', function() {
  $('body').css('overflow', 'auto')
  // enableScroll()
  $(this).closest('.modal-container').removeClass('open')
  // document.body.style.paddingRight = 0;
});



function variantPdce() {
  let qtyPd = document.querySelectorAll('#quantity');
  let variantPd = document.querySelectorAll('.selected-variant-dropdown');

  if (qtyPd.length > 0) {
    qtyPd.forEach(qty => {

      if(qty.dataset.bound) return;
      qty.dataset.bound = 'true';

      qty.addEventListener('change', function () {

        let val = parseInt(this.value,10) || 1;
        let $this = this.closest('.product-main');

        if(!$this) return;

        const elements = [
          { selector: '.modal_price .price', dataAttr: 'price' },
          { selector: '#cs-split-price', dataAttr: 'price' },
          { selector: '.modal_price [data-compareprice]', dataAttr: 'compareprice' },
          { selector: '.modal_price [data-saveprice]', dataAttr: 'saveprice' }
        ];

        elements.forEach(el => {
          const element = $this.querySelector(el.selector);

          if(element && element.dataset[el.dataAttr]){
            const price = Number(element.dataset[el.dataAttr]) * val;

            element.innerHTML = window.Shopify.formatMoney(
              price,
              document.body.dataset.moneyFormat
            );
          }
        });

      });

    });
  }


  if (variantPd.length > 0) {

    variantPd.forEach(option => {

      if(option.dataset.bound) return;
      option.dataset.bound = 'true';

      option.addEventListener('change', function () {

        let thisId = this.value;
        let qtyVal =
          parseInt(document.getElementById('quantity')?.value,10) || 1;

        let productHtml = this.closest('.product_form');
        if(!productHtml || !productHtml.dataset.product) return;

        let prodData;

        try{
          prodData = JSON.parse(productHtml.dataset.product);
        } catch(e){
          return;
        }

        prodData.variants.forEach(variant => {

          if(variant.id == thisId){

            let finalPrice = variant.price * qtyVal;

            let mainElement =
              productHtml.closest('.product__details');

            if(mainElement){
              let mainPrice =
                mainElement.querySelector('.modal_price span.price');

              if(mainPrice){
                mainPrice.innerHTML = window.Shopify.formatMoney(
                  finalPrice,
                  document.body.dataset.moneyFormat
                );

                mainPrice.setAttribute('data-price', finalPrice);
              }
            }

          }

        });

      });

    });

  }
}